// Generated by CoffeeScript 2.7.0
import {
  keymap
} from 'prosemirror-keymap';

import {
  baseKeymap
} from 'prosemirror-commands';

import {
  buildKeymap
} from 'prosemirror-example-setup';

import schema from './schema.js';

export var slpBaseKeymap = keymap(baseKeymap);

export var slpKeymap = keymap(buildKeymap(schema));
